export const MAX_LEN_RESULT_TITLE = 140;
export const MAX_LEN_RESULT_SUBTITLE = 700;
export const MAX_LEN_RESULT_MEDIA_CAPTION = 150;
export const MAX_LEN_RESULT_CROSSWORD_MEDIA_CAPTION = 150;
export const MIN_LEN_RESULT_TITLE = 3;
